onInteractive(function () {
	// De tekst-op-fotosectie staat full width in de opmaak; plaats hem binnen de containerbreedte.
	document.querySelectorAll('.text-image-section .clamp-left-unclamp-right').forEach(function (block) {
		var container = document.createElement('div');
		container.className = 'container';

		block.parentNode.insertBefore(container, block);
		container.appendChild(block);
	});
});
